module.exports = __webpack_public_path__ + "img/42.8b79c000.png";